module.exports = __webpack_public_path__ + "img/1217379211.b8669e1c.jpg";